import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  StyledEmployerDirectory,
  StyledEmployerName,
  StyledEmployerLastName,
  StyledEmployerAlias,
  StyledPhoto,
  StyledEmployerTableCell,
  StyledEmployerTableCellDepartment,
  StyledEmployerTableCellExtension,
  StyledEmployerTableCellPhones,
  StyledEmployerTableCellEmail,
  StyledWrapperPhoto,
  StyledIcon,
  IconButton
} from './style';

import { Envios, Chat, Arrow } from '../../../../assets/images/index';
import { AVATAR_MEDIUM } from '../../../utils/crops';

class RowDirectory extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.state = { active: false };
  }

  onClick() {
    const { active } = this.state;
    this.setState({ active: !active });
  }

  render() {
    const { dataRow } = this.props;
    return (
      <StyledEmployerDirectory
        active={this.state.active}
        onClick={() => this.handleLink('link')}
      >
        <IconButton
          svg={Arrow}
          size="s"
          hover
          active={this.state.active}
          onClick={this.onClick}
        />
        <StyledWrapperPhoto>
          <StyledPhoto
            name={dataRow.name}
            lastname={dataRow.lastname}
            userId={String(dataRow.userId)}
            crop={AVATAR_MEDIUM}
            avatarPhoto={dataRow.avatarPhoto && dataRow.avatarPhoto}
            directory
          />
        </StyledWrapperPhoto>
        <StyledEmployerName title={dataRow.name}>
          {' '}
          {dataRow.name}{' '}
        </StyledEmployerName>
        <StyledEmployerLastName title={dataRow.lastname}>
          {' '}
          {dataRow.lastname}{' '}
        </StyledEmployerLastName>
        <StyledEmployerAlias title={dataRow.alias}>
          {' '}
          {dataRow.alias}{' '}
        </StyledEmployerAlias>
        <StyledEmployerTableCellDepartment title={dataRow.department}>
          {dataRow.department}
        </StyledEmployerTableCellDepartment>
        <StyledEmployerTableCellExtension title={dataRow.extension}>
          {' '}
          {dataRow.extension}{' '}
        </StyledEmployerTableCellExtension>
        <StyledEmployerTableCellPhones title={dataRow.corporatePhone}>
          {dataRow.corporatePhone}
        </StyledEmployerTableCellPhones>
        <StyledEmployerTableCellEmail title={dataRow.email}>
          {' '}
          {dataRow.email}{' '}
        </StyledEmployerTableCellEmail>
        <StyledEmployerTableCell>
          {/* {dataRow.userId ? (
            <a
              href={`/perfil/${dataRow.userId}/mi_perfil`}
              title={`Ver perfil de ${dataRow.name}`}
              rel="noopener noreferrer"
            >
              <StyledIcon svg={Persona} size="m" profilee="button" hover />
            </a>
          ) : (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              href="/directorio_empleados"
              title="No tiene perfil"
              rel="noopener noreferrer"
            >
              <StyledIcon svg={Persona} size="m" profilee="button" hover />
            </a>
          )} */}
          <a
            href={
              dataRow.email
                ? `https://outlook.office.com/owa/?path=/mail/action/compose&to=${dataRow.email}`
                : 'https://outlook.office.com/mail/inbox'
            }
            title={`Enviar email a ${dataRow.name}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <StyledIcon svg={Envios} size="m" profilee="button" hover />
          </a>
          <a
            href={
              dataRow.email
                ? `https://teams.microsoft.com/l/chat/0/0?users=${dataRow.email}`
                : 'https://teams.microsoft.com/'
            }
            title="Iniciar chat"
            target="_blank"
            rel="noopener noreferrer"
          >
            <StyledIcon svg={Chat} size="m" profilee="button" hover />
          </a>
        </StyledEmployerTableCell>
      </StyledEmployerDirectory>
    );
  }
}

RowDirectory.propTypes = {
  dataRow: PropTypes.shape({
    userId: PropTypes.number,
    name: PropTypes.string,
    lastname: PropTypes.string,
    alias: PropTypes.string,
    profile: PropTypes.string,
    department: PropTypes.string,
    extension: PropTypes.number,
    phones: PropTypes.string,
    email: PropTypes.string,
    chatUrl: PropTypes.string
  })
};

RowDirectory.defaultProps = {
  dataRow: {
    chatUrl: 'https://teams.microsoft.com/'
  }
};

export default withRouter(RowDirectory);
